
(function ($) {

  function ready() {
    if ($('#not-found-impression').length > 0) {
      setTimeout(function () {
        if (ux.traffic && ux.traffic.impression) {
          ux.traffic.impression('mcx.help.404.impression');
        }
      }, 100);
    }
  }

  $(document).ready(ready);

}(jQuery));
